import { render, staticRenderFns } from "./YearProductReport.vue?vue&type=template&id=114a29e0&"
import script from "./YearProductReport.vue?vue&type=script&lang=ts&"
export * from "./YearProductReport.vue?vue&type=script&lang=ts&"
import style0 from "./YearProductReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports